import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfOrganizations } from '../../organizationSchema'

export default organizations => {
    const organizationsData = pathOr([], ['_embedded', 'hotels24Organizations'], organizations)
    return { ...normalize(organizationsData, arrayOfOrganizations) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/h24Parsers/h24Organizations.js